module.exports = __webpack_public_path__ + "static/media/leaf.ae954bbc.svg";